import { Link } from "react-router-dom";

export default function BlogCard({ blog }) {
    return (
        <li>
            <img src={blog.featured_image_url} alt={blog.featured_image_alt || blog.title} width={400} height={300} loading="lazy" />
            <Link to={`/blogs/${blog.slug}`}>
                <h4>{blog.title}</h4>
            </Link>
        </li>
    );
}